import React from 'react'
import { Route, Switch } from 'utils-next/routes'

import { UserDetailsView, UserListView } from './scenes'
import { USER_MANAGER_DETAILS_PATH, USER_MANAGER_LIST_PATH } from './UserManager.routes'

export function UserManager() {
  return (
    <Switch>
      <Route path={USER_MANAGER_LIST_PATH} component={UserListView} exact />
      <Route path={USER_MANAGER_DETAILS_PATH} component={UserDetailsView} />
    </Switch>
  )
}
